import { activityStatus } from '../../Model/CoachActivity';

/*
  What the admin page shows as a task's status. Its stored status, bar one state nothing stores: a highlight
  task the client said no to (stored as REMOVED, which the page otherwise never shows).
*/
const TaskDisplayStatus = {
  IN_PROGRESS: activityStatus.IN_PROGRESS,
  AWAITING_CLIENT_CONSENT: activityStatus.AWAITING_CLIENT_CONSENT,
  CLIENT_DECLINED: 'CLIENT_DECLINED',
  COMPLETED: activityStatus.COMPLETED,
};

const displayStatusOf = (task) => {
  if (task.isDeclinedByClient) {
    return TaskDisplayStatus.CLIENT_DECLINED;
  }
  return task.status;
};

/*
  Which coaches the dashboard lists: the ones the logged-in AC/CAM manages, every coach, or - for any other value - the
  coaches of the CAM with that user id.
*/
const CoachSet = {
  MINE: 'MINE',
  ALL: 'ALL',
};

/**
 * Groups current CAM assignments into the dashboard's CAM choices.
 * A CAM is keyed by user id, since two CAMs can share a first name; the name is only what the picker shows.
 * @param {Array<{ userId: string, userName: string, coach: string }>} assignments current CAM assignments
 * @returns {{ camOptions: Array<{ id: string, name: string }>, coachIdsByCam: Object<string, string[]> }} the CAMs
 * sorted by name, and each CAM's coach ids
 */
const groupCamAssignments = (assignments) => {
  const namesById = {};
  const coachIdsByCam = {};
  assignments.forEach(({ userId, userName, coach }) => {
    if (!userId || !coach) {
      return;
    }
    namesById[userId] = namesById[userId] || userName || userId;
    coachIdsByCam[userId] = [...new Set([...(coachIdsByCam[userId] || []), coach])];
  });
  const camOptions = Object.entries(namesById)
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
  return { camOptions, coachIdsByCam };
};

/**
 * The coach ids the dashboard lists for a coach set.
 * @param {string} coachSet CoachSet.MINE, CoachSet.ALL or a CAM's user id
 * @param {{ managedCoachIds: string[], allCoachIds: string[], coachIdsByCam: Object<string, string[]> }} sources
 * @returns {string[]} the coach ids to list
 */
const coachIdsForSet = (coachSet, { managedCoachIds, allCoachIds, coachIdsByCam }) => {
  if (coachSet === CoachSet.MINE) {
    return managedCoachIds;
  }
  if (coachSet === CoachSet.ALL) {
    return allCoachIds;
  }
  return coachIdsByCam[coachSet] || [];
};

export {
  TaskDisplayStatus,
  displayStatusOf,
  CoachSet,
  groupCamAssignments,
  coachIdsForSet,
};
